











import {Component, Vue, Prop} from 'vue-property-decorator';

@Component
export default class Select extends Vue {

  @Prop({default: () => []}) selectItems!: object[];
  @Prop({default: ''}) label!: string;

  selectedCategory = 'battery'

  pickCategory() {
    this.$emit('pickCategory', this.selectedCategory)
  }
}
